import React, { useState } from 'react';
import { Box, Paper, Typography, TextField, Button, Alert } from '@mui/material';
import { fetchApi } from './fetchApi';

type Props = {
  onVerified: () => Promise<void> | void;
};

function TwoFactorPage({ onVerified }: Props) {
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);

    const trimmed = code.trim();
    if (!trimmed) return;

    setLoading(true);
    try {
      await fetchApi('/api/auth/totp/verify', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token: trimmed }),
      });

      await onVerified();
    } catch (err: any) {
      setError(
        err?.message === '403'
          ? '2FA Code ungültig oder abgelaufen.'
          : err?.message || 'Fehler bei der 2FA-Verifizierung.'
      );
    } finally {
      setLoading(false);
    }
  }

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}>
      <Paper elevation={3} sx={{ width: '100%', maxWidth: 420, p: 3 }}>
        <Typography variant="h5" sx={{ mb: 2 }}>
          Zwei-Faktor-Authentifizierung
        </Typography>

        <Typography sx={{ mb: 1, opacity: 0.8 }}>
          Bitte den 6-stelligen Code aus deiner Authenticator-App eingeben.
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        <Box component="form" onSubmit={handleSubmit} noValidate>
          <TextField
            label="2FA Code"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            fullWidth
            margin="normal"
            autoComplete="one-time-code"
            inputProps={{
              inputMode: 'numeric',
              pattern: '[0-9]*',
              maxLength: 8,
            }}
          />

          <Button type="submit" variant="contained" fullWidth disabled={loading || !code.trim()} sx={{ mt: 2 }}>
            {loading ? 'Bitte warten…' : 'Bestätigen'}
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}

export default TwoFactorPage;
